import {ColumnMain} from "#/models/column-main";
import {Column} from "#/models/column";
import {Trans} from "@lingui/macro";
import {Tag} from "antd";
import React from "react";

const DmcControlReadingModel = () : ColumnMain => {

    const columns : Array<Column> = new Array();
    columns.push({key:'id', width: 80, filter:true, sorter:true,title:<Trans>#</Trans>});
    columns.push({key:'labelData', width: 400, filter:true, sorter:true,title:<Trans>Data</Trans>});
    columns.push({
        key: 'result',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>OK_</Trans>,
                value: 'OK',
            },
            {
                label: <Trans>NOK</Trans>,
                value: 'NOK',
            }
        ],
        sorter: true,
        width: 150,
        title: <Trans>Result</Trans>,
        render: text => {
            let color = 'gray';
            let transText;
            if (text === 'NOK') {
                color = 'red';
                transText = <Trans>NOK</Trans>;
            } else if (text === 'OK') {
                color = 'green';
                transText = <Trans>OK_</Trans>;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });

    columns.push({
        key: 'labelQuality',
        uniqueSelectFilterData: [
            {
                label: <Trans>All</Trans>,
                value: null,
            },
            {
                label: <Trans>A</Trans>,
                value: 'A',
            },
            {
                label: <Trans>B</Trans>,
                value: 'B',
            },
            {
                label: <Trans>C</Trans>,
                value: 'C',
            },
            {
                label: <Trans>D</Trans>,
                value: 'D',
            },
            {
                label: <Trans>E</Trans>,
                value: 'E',
            },
            {
                label: <Trans>F</Trans>,
                value: 'F',
            }
        ],
        sorter: true,
        width: 150,
        title: <Trans>Label Quality</Trans>,
        render: text => {
            let color = 'gray';
            let transText = text;
            if (text === 'A') {
                color = '#5b8c00';
                transText = <Trans>A</Trans>;
            } else if (text === 'B') {
                color = '#d3f261';
                transText = <Trans>B</Trans>;
            } else if (text === 'C') {
                color = '#ffc53d';
                transText = <Trans>C</Trans>;
            } else if (text === 'D') {
                color = '#d48806';
                transText = <Trans>D</Trans>;
            } else if (text === 'E') {
                color = '#fa541c';
                transText = <Trans>E</Trans>;
            } else if (text === 'F') {
                color = '#f5222d';
                transText = <Trans>F</Trans>;
            }
            return (
                <Tag color={color} key={text}>
                    {transText}
                </Tag>
            );
        },
    });



    columns.push({key:'updatedDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Updated Date</Trans>});
    columns.push({key:'updatedBy', width: 150, sorter:true,title:<Trans>Updated By</Trans>});
    columns.push({key:'createdDate', width: 150, dateTimeFilter:true, sorter:true,title:<Trans>Created Date</Trans>,direction:"desc"});
    columns.push({key:'createdBy', width: 150, sorter:true,title:<Trans>Created By</Trans>});


    return{
        columns:columns,
        url:"/resource/dmc-control-readings"
    };

}
export default DmcControlReadingModel();
